import PreviewPay from "../Previews/Deal/PreviewPay/PreviewPay";
import TabPreview from "../Previews/Destination/1";
import Destination2 from "../Previews/Destination/2/Preview";
import Destination3 from "../Previews/Destination/3/Preview";
import DealCards from "../Previews/Destination/4/Preview";
import OnboardPromtion4 from "../Previews/Destination/5/Preview";
import MICE2Card from "../Previews/Mice/MICE2Card/Preview";
import CashVoucherCard from "../Previews/Deal/CashVoucharcard/preview"
import Mice3Card from "../Previews/Mice/Mice3card/Preview";
import OnboardPreview from "../Previews/OnboardPreview/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";
import ShipDealPreview from "../Previews/Ship/DealCard/Preview";
import CashVoucherCard1 from "../Previews/Deal/CashVoucharcard1/Preview";

export const cashvoucherPackages = {
    form: [
        {
            title: "Page Name",
            key: "page_name",
            className: "col-lg-12",
            type: "input",
        },
        {
            title: "Meta Description",
            key: "meta_description",
            className: "col-lg-12",
            type: "input",
        },
    ],
    component: [
        {
            type: 1,
            fields: [
                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },

                {
                    title: "Page Image",
                    key: "image",
                    className: "col-lg-12",
                    placeholder: "Upload Page Image",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
            ],
            preview: (activetab, cardData) => (
                <ShipBannerPreview activetab={activetab} cardData={cardData} />
            ),
        },
        {
            type: 2,
            fields: [
                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
            ],
            preview: (activetab, cardData) => (
                <CashVoucherCard activetab={activetab} cardData={cardData} />
            ),
        },
        {
            type: 2,
            level1: [
                {
                    title: "Card Image",
                    key: "image",
                    className: "col-lg-12",
                    placeholder: "Upload Card Image",
                    type: "file",
                    withAlt: true,
                    required: false,
                },

                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },


                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                    required: false,
                },

            ],
            preview: (activetab, cardData) => (
                <CashVoucherCard1 activetab={activetab} cardData={cardData} />
            ),
        },

        {
            type: 3,
            fields: [
            ],
            level1: [
                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },


                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                },

            ],
            level2: [
                {
                    title: "Card Icon",
                    key: "image",
                    className: "col-lg-12",
                    placeholder: "Upload Card Image",
                    type: "file",
                    withAlt: true,
                    required: false,
                },
                {
                    title: "English Title",
                    key: "title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Simplified Chinese Title",
                    key: "simplified_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Traditional Chinese Title",
                    key: "traditional_chinese_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },
                {
                    title: "Bahasa Title",
                    key: "bahasa_title",
                    className: "col-lg-3",
                    type: "input",
                    required: false,
                },

                {
                    title: "English Description",
                    key: "description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Simplified Chinese Description",
                    key: "simplified_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Traditional Chinese Description",
                    key: "traditional_chinese_description",
                    className: "col-lg-3",
                    type: "html",
                },
                {
                    title: "Bahasa Description",
                    key: "bahasa_description",
                    className: "col-lg-3",
                    type: "html",
                },

            ],
            preview: (activetab, cardData) => (
                <TabPreview activetab={activetab} cardData={cardData} />
            ),
        },
    ],
};
